import { render } from "./StatProject.vue?vue&type=template&id=0b015e70"
import script from "./StatProject.vue?vue&type=script&lang=js"
export * from "./StatProject.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__